
import React from "react";
import Alert from 'react-s-alert';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { OnGetJson, OnGetJsoni, GetCorService, genURL } from '../_getjson.js';
import SelectFix from './SelectFix';
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import axios from 'axios'
import Grid from '@mui/material/Grid';
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers"
var cdate = require("./../_source/timeFn")

require('./../_css/PopUpOther.css');
const mystyle = {
    paddingTop: '0px',
    // paddingLeft:'0px'
};
export default class SearchDoc extends React.Component {
    constructor(props) {
        super(props);
        this.DOCNO1 = React.createRef();
        this.DOCNO2 = React.createRef();
        this.ARCODE = React.createRef();
        this.REFDOCNO = React.createRef();
        this.APCODE = React.createRef();
        this.itemlist = React.createRef();
        this.state = {
            rows: [],
            Htext: '',
            _from: '',
            openBackdrop: false,
            DATE1: cdate.startdateDDMMYYYY(),
            DATE2: '',
        }
    }
    componentDidMount() {
        this.setState({ _from: this.props.from });
        setTimeout(() => {
            this.onSearch();
        }, 200);
    }

    onClose = (e) => {
        this.props.closePopup();
    }
    ViewCSTV = (DATA) => {
        switch (DATA) {
            case "CSSTKISSUE": this.setState({ Htext: "บันทึกใบเบิกสินค้า" }); return "CSSTKISSUE/Search?"; break;
            case "CSSTKISSUEREQ": this.setState({ Htext: "บันทึกใบเบิกสินค้า" }); return "CSSTKISSUEREQ/Search?"; break;
            // case "CSRECEIPT": this.setState({Htext:"บันทึกรายได้อื่นๆ"});   return "CSRECEIPT/SEARCH"; break; 
            default: break;
        }
    }
    onSearch = async () => {
        this.setState({ openBackdrop: true })
        var url = this.ViewCSTV(this.props.from);
        url += "&DATE1=" + cdate.DateYYYYMMDD(this.state.DATE1);
        url += "&DATE2=" + cdate.DateYYYYMMDD(this.state.DATE2);
        url += "&DOCNO1=" + this.DOCNO1.current.value;
        url += "&DOCNO2=" + this.DOCNO2.current.value;
        url += "&ARCODE=" + this.ARCODE.current.value;
        url += "&APCODE=" + this.APCODE.current.value;
        url += "&REFDOCNO=" + this.REFDOCNO.current.value;
        url += "&top=" + this.itemlist.current.value;
        console.log("genURL", genURL(url));
        await axios.get(genURL(url), { timeout: 60000 }).then(async res => {
            if (res.data.length > 0) {
                var data = [];
                for (var i = 0; i < res.data.length; i++) {
                    data[i] = await {
                        C0: i + 1,
                        C1: cdate.DateDDMMYYYY(res.data[i].DOCDATE),
                        C2: res.data[i].DOCNO,
                        C3: res.data[i].ARCODE,
                        C4: res.data[i].ARNAME,
                        C5: res.data[i].REMARK
                    }
                    // if(res.data[i].APCODE){
                    //     data[i].C3 = res.data[i].APCODE;
                    //     data[i].C4 = res.data[i].APNAME;
                    //     data[i].C5 = res.data[i].REMARK;                 
                    // }
                    if (i === res.data.length - 1) {
                        await this.setState({ rows: data });
                        this.setState({ openBackdrop: false })
                    }
                }
            } else {
                var data = [];
                this.setState({ rows: data });
                this.setState({ openBackdrop: false })
            }
        }).catch(error => {
            console.log(error);
            this.setState({ openBackdrop: false })
        });
    }
    SelectSetData = (data1, data2) => {
        switch (data1) {
            case "Calendar1": this.setState({ DATE1: data2 }); break;
            case "Calendar2": this.setState({ DATE2: data2 }); break;
        }
    }
    onSelectRow = (data) => {
        this.props.Get_Popup(data);
        this.props.closePopup();
    }
    KeyUp = (e) => {
        switch (e.target.id) {
            case "DOCNO1":
                this.DOCNO2.current.value = e.target.value;
                break;
            default:
                break;
        }
        // console.log(e.key);
        if (e.key === "Enter") {
            this.onSearch();
        }
    }
    render() {
        return (
            <div className='popup' >
                <Backdrop open={this.state.openBackdrop} />
                <br />
                <br />
                <br />
                <div className='popup_inner'>
                    {/* <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-search"> {this.state.Htext}  </i></div>
                        <div className="PopUpOtherDivH2"><i className="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div> */}
                    <div className="panel-body divTable" align="right">

                        <Grid container spacing={2}>
                            <Grid item xs={6} >
                                <MaterialUIPickers title="วันที่"
                                    DateValue={e => this.SelectSetData("Calendar1", e)}
                                    defaultdate={this.state.DATE1}
                                    Popup={true} />
                            </Grid>
                            <Grid item xs={6}>

                                <MaterialUIPickers title="ถึง"
                                    DateValue={e => this.SelectSetData("Calendar2", e)}
                                    defaultdate={this.state.DATE2}
                                    Popup={true} />

                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span className="input-group-addon"> เลขที่เอกสาร  </span>
                                        <input type="text" className="form-control" id="DOCNO1" ref={this.DOCNO1} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span id="iconCreditCode" className="input-group-addon ">ถึง  </span>
                                        <input type="text" className="form-control" id="DOCNO2" ref={this.DOCNO2} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span className="input-group-addon"> เลขบัตรลูกค้า  </span>
                                        <input type="text" className="form-control" id="ARCODE" ref={this.ARCODE} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span id="iconCreditCode" className="input-group-addon ">เอกสารอ้างอิง  </span>
                                        <input type="text" className="form-control" id="REFDOCNO" ref={this.REFDOCNO} onKeyUp={this.KeyUp} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span className="input-group-addon">เลขบัตรเจ้าหนี้  </span>
                                        <input type="text" className="form-control" ref={this.APCODE} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6} style={mystyle}>
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 FromGroupPOPUP">
                                    <div className="float-left input-group col-xs-12 col-sm-12 col-lg-12 col-md-12 form-inline1">
                                        <span className="input-group-addon">จำนวนรายการ  </span>
                                        <input type="text" className="form-control" ref={this.itemlist} />
                                        <span className="input-group-addon icon"><i className="fab fa-expeditedssl"></i></span>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                        <button className="PUSDbtn" onClick={this.onSearch.bind(null)}><i className="fas fa-search" > ค้นหา </i></button>
                        <BootstrapTable
                            data={this.state.rows}
                            options={{
                                onRowClick: this.onSelectRow,
                                noDataText: "ไม่พบข้อมูล"
                            }}
                            height='650'
                            hover condensed>
                            <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="40" dataField='C0' isKey> </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="100" dataField='C1'> วันที่เอกสาร </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="120" dataField='C2'> เลขที่เอกสาร </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="120" dataField='C3'> รหัสลูกค้า </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="200" dataField='C4'> ชื่อลูกค้า </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="140" dataField='C5'> หมายเหตุ </TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </div>
        );
    }
}
